import { Component, OnInit } from '@angular/core';
import { PrivacyPolicyService } from './privacy-policy.service';
import { ToastService } from '../common/toast.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  loading: boolean = false;
  privacyData: any = null;
  errorMessage: string = '';

  constructor(
    private privacyService: PrivacyPolicyService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.loadPrivacyData();
  }

  loadPrivacyData() {
    this.loading = true;
    this.errorMessage = '';
    
    this.privacyService.getPrivacyPolicyData().subscribe(
      (response) => {
        this.loading = false;
        if (response && response.status === 'success') {
          this.privacyData = response.data;
        } else {
          this.errorMessage = (response && response.message) || 'Failed to load privacy policy';
          this.toast.error(this.errorMessage);
        }
      },
      (error) => {
        this.loading = false;
        this.errorMessage = 'An error occurred while loading privacy policy';
        this.toast.error(this.errorMessage);
        console.error('Error loading privacy policy:', error);
      }
    );
  }
}




// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/privacy-policy/privacy-policy.component.ts